export function operationsPipe(initialInput: any, ...fns: Function[]) {
  return fns.reduce((fnInput, fn) => fn(fnInput), initialInput);
}

export function extractFileExtension(filepath: string) {
  return filepath.slice(filepath.search(/\.\w+$/)).replace(/\./, '');
}
